module.exports = __webpack_public_path__ + "img/backgroundImg.f4a7e867.jpg";